// extracted by mini-css-extract-plugin
module.exports = {"container":"SavedArticlesTemplate_SavedArticles_container","wrapper":"SavedArticlesTemplate_SavedArticles_wrapper"};